// Message.js
import React from 'react';

function Message({ type, text }) {
  const messageClass = `message ${type}`;
  return <div className={messageClass}>{text}</div>;
}

export default Message;